import { render, staticRenderFns } from "./AzChatButton.vue?vue&type=template&id=67724e39&"
import script from "./AzChatButton.vue?vue&type=script&lang=js&"
export * from "./AzChatButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports